import React from 'react';
import LocalGovernmentForm from "../../components/PagesForm/LocalGovernmentForm";

function LocalGovernmentAdd() {
    return (
        <LocalGovernmentForm isEdit={false} />
    );
}

export default LocalGovernmentAdd;